import { trackClickEvent } from '@/common/js/omega';
import moment from 'moment';

/**
 * 统计用户 LocalStorage 使用情况
 * @param {项目名} proName 
 * @returns 
 */
export const trackLocalStorage = (proName) => {
    try {
        if(moment().isAfter(moment('2024-1-12')) || !window.localStorage) return

        // 每一个用户只上传一次
        if(localStorage.getItem('storageIsUpload') === '1') return
        localStorage.setItem('storageIsUpload', '1')

        var total = 0;
        for(var key in localStorage) {
            var item = localStorage.getItem(key)
            var blob = new Blob([item], {type: 'text/plain'});
            let itemSize = (blob.size)
            // 上报 key itemSize userid 信息
            trackClickEvent('tech_cs_storage', {
                pro_name: proName,
                key: key,
                size: itemSize,
            })
            total += +itemSize
        }
        // 上报总sorage大小、userid、仓库地址等信息
        trackClickEvent('tech_cs_storage', {
            total_size: total/1024,
            pro_name: proName,
        })
    } catch(e) {}
}
